import * as yup from 'yup';
import { buildRequiredEmailLikeSchema } from 'pages/Auth/utils';
import {
  RESET_PASSWORD_EMAIL_FORMAT_ERROR,
  RESET_PASSWORD_EMAIL_REQUIRED_ERROR,
} from './ResetPassword.constants';

export const RESET_PASSWORD_SCHEMA = yup.object({
  email: buildRequiredEmailLikeSchema(RESET_PASSWORD_EMAIL_REQUIRED_ERROR, RESET_PASSWORD_EMAIL_FORMAT_ERROR),
});
